import Modal from '@qc/particle/lib/components/modal'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Notification, NotificationStatus, NotificationViewed } from '../../../models'
import NotificationPopup from './NotificationPopup'

import { DataService } from '../../../dataService'
import { GlobalNavContext } from '../../../GlobalNav'
import GlobalNavPopupContext, { PopupType } from '../../../PopupContext'

import { faBell } from '@fortawesome/pro-light-svg-icons/faBell'
import { faBell as faBellSolid } from '@fortawesome/pro-solid-svg-icons/faBell'

import ActionIcon from '../ActionIcon'

import styles from './NotificationDropdown.scss'
import { Dropdown } from '../../Dropdown'

export interface Props {
  dataService: DataService
  className?: string
}

const NotificationDropdown = ({ className = '', dataService }: Props) => {
  const navContext = useContext(GlobalNavContext)
  const popupContext = useContext(GlobalNavPopupContext)
  const [notifications, setNotifications] = useState<Notification[]>([])
  const [newMessageIndicator, setNewMessageIndicator] = useState(false)
  const account = navContext.account
  const [viewedNotifications, setViewedNotifications] = useState<Notification[]>([])
  useEffect(() => {
    dataService.getNotifications(account).then((notifs) => {
      setNotifications(notifs.sort((a, b) => a.id >= b.id ? -1 : 1))
    })
  },        [account])
  useEffect(() => {
    setNewMessageIndicator(notifications.filter(notif => notif.status === NotificationStatus.ACTIVE).length > 0)
  },        [notifications])

  const onVisibilityChange = (notification: Notification) => {
    if (notification.viewed !== NotificationViewed.READ) {
      dataService.markNotificationAsRead([notification])
      setViewedNotifications([... viewedNotifications, notification])
    }
  }
  const onChangeNotificationStatus = (notification: Notification) => {
    let newStatus = NotificationStatus.ARCHIVED
    if (notification.status === NotificationStatus.ARCHIVED) {
      newStatus = NotificationStatus.ACTIVE
    }
    dataService.updateNotificationStatus([notification], newStatus)
    if (newStatus === NotificationStatus.ARCHIVED) {
      onVisibilityChange(notification)
    }
    setNotifications(notifications.map((notif) => {
      if (notif.id === notification.id) {
        notif.status = newStatus
      }
      return notif
    }))
  }
  const closePopup = useCallback((event: React.MouseEvent) => {
    if (event && event.isPropagationStopped()) {
      return
    }
    viewedNotifications.forEach((viewedNotification) => {
      setNotifications(notifications.map((notif) => {
        if (notif.id === viewedNotification.id) {
          notif.viewed = NotificationViewed.READ
        }
        return notif
      }))
    })
    setViewedNotifications([])
  },                             [popupContext])
  return (
    <Dropdown
      width={560}
      icon={faBell}
      offset={20}
      iconHover={faBellSolid}
      modalClassName={`${styles.container} ${className}`}
      data-cy="notificationContainer"
      type={PopupType.NOTIFICATION}
      onClose={closePopup}
      actionIconChildren={(
        (newMessageIndicator) ? <sup className={styles.badge_dot} /> : null
      )}
    >
      <NotificationPopup
            onArchive={onChangeNotificationStatus}
            notifications={notifications}
            onVisibilityChange={onVisibilityChange}
          />
    </Dropdown>
  )
}

export default NotificationDropdown
